import * as fromTemporaries from "../../temporaries/temporariesReducer"

/**
 * Verify if the menu is responsive
 */
export const isMenuResponsive = state => fromTemporaries.isMenuResponsive(state.temporaries)
